export enum LocalStorageKey {
  ACCESS_TOKEN = 'token',
  DEBUG = 'debug',
  IS_CHIPS_CONVERTED_TO_BLINDS = 'is_chips_converted_to_blinds',
  CHAT_HEIGHT = 'chat_height',
  IS_PINNED_SIDEBAR = 'is_pinned_sidebar',
  ACTIVE_TAB = 'active_tab',
  AUTO_FILTER_OPTIONS = 'auto-filter-options',
}
